import * as React from 'react';

function SvgContactFaq(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={94} height={70} {...props}>
      <defs>
        <clipPath id="contact_faq_svg__a" />
      </defs>
      <g fill="#008afd" clipPath="url(#contact_faq_svg__a)" data-name="Mask Group 1" opacity={0.9}>
        <ellipse
          cx={61.25}
          cy={60.969}
          data-name="Ellipse 34"
          opacity={0.5}
          rx={61.25}
          ry={60.969}
          transform="translate(-28.5 -24.496)"
        />
        <ellipse
          cx={44.866}
          cy={47.786}
          data-name="Ellipse 35"
          rx={44.866}
          ry={47.786}
          transform="translate(-12.116 -11.313)"
        />
      </g>
      <path
        d="M51.236 26.762a3.984 3.984 0 01-1.833 2.99c-.293.246-.838.695-.837.863a1.173 1.173 0 01-1.186 1.183h-.01a1.176 1.176 0 01-1.19-1.164 3.567 3.567 0 011.687-2.7c.594-.5.983-.849.983-1.17a1.179 1.179 0 00-2.357 0 1.191 1.191 0 11-2.382 0 3.561 3.561 0 017.121 0zm-3.829 6.135a1.169 1.169 0 00-1.165 1.191v.009a1.165 1.165 0 001.165 1.187 1.193 1.193 0 000-2.387zm-24.008 8.3a1.191 1.191 0 000 2.382h.1a1.191 1.191 0 000-2.382zm4.14 0a1.191 1.191 0 000 2.382h.1a1.191 1.191 0 000-2.382zM62.52 22.172v13.4a5.726 5.726 0 01-5.719 5.75H41.354c-.3 0-.551 0-.759-.006s-.463-.006-.559 0c-.1.066-.344.29-.579.507-.093.086-.2.18-.313.284l-4.37 3.983a1.219 1.219 0 01-2.031-.88V32.592H20.266a3.413 3.413 0 00-3.4 3.386v13.406a3.361 3.361 0 003.4 3.324H37.52a1.2 1.2 0 01.794.337l3.56 3.283V45.007a1.191 1.191 0 112.382 0v14.02a1.174 1.174 0 01-.7 1.083 1.142 1.142 0 01-.472.1 1.2 1.2 0 01-.8-.324l-5.222-4.791H20.266a5.745 5.745 0 01-5.786-5.711V35.978a5.8 5.8 0 015.786-5.768h12.477v-8.038a5.778 5.778 0 015.806-5.724h18.252a5.7 5.7 0 015.719 5.724zm-2.382 0a3.319 3.319 0 00-3.337-3.342H38.549a3.393 3.393 0 00-3.424 3.342v20.35l2.395-2.164c.111-.1.235-.194.326-.278a3.007 3.007 0 012.8-1.139c.195 0 .426.006.709.006h15.446a3.341 3.341 0 003.337-3.375v-13.4z"
        data-name="discuss-issue (1)"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgContactFaq;
